// src/components/PrivacyPolicy.jsx
import { usePageMeta } from "../utils/pageMeta";

export default function PrivacyPolicy({ onBack }) {
  usePageMeta({
    title: "개인정보처리방침",
    description: "펫말 개인정보처리방침 — 수집하는 정보와 이용 목적, 보관 및 보호 방법을 안내합니다.",
    canonicalPath: "/privacy",
  });
  const section = {
    marginBottom: 28,
  };
  const h2 = {
    fontFamily: "'Jua', sans-serif",
    fontSize: 18,
    fontWeight: 700,
    color: "#5c3d2e",
    marginBottom: 10,
  };
  const p = {
    fontSize: 16,
    fontWeight: 400,
    color: "#6b5040",
    lineHeight: 2,
  };

  return (
    <div style={{ maxWidth: 600, margin: "0 auto", padding: "0 20px" }}>
      <button
        onClick={onBack}
        style={{
          display: "inline-flex", alignItems: "center", gap: 6,
          color: "#b09070", fontSize: 16, fontWeight: 400, cursor: "pointer",
          border: "none", background: "none",
          fontFamily: "'Gowun Batang', serif",
          padding: "8px 0", margin: "24px 0 20px",
        }}
      >
        ← 돌아가기
      </button>

      <div style={{
        background: "white",
        borderRadius: 24,
        padding: "36px 32px",
        boxShadow: "0 4px 24px rgba(92,61,46,0.07)",
        animation: "fadeUp .5s ease",
      }}>
        <div style={{ fontFamily: "'Jua', sans-serif", fontSize: 24, fontWeight: 700, color: "#5c3d2e", marginBottom: 6 }}>
          개인정보처리방침
        </div>
        <div style={{ fontSize: 13, color: "#b09070", marginBottom: 28 }}>
          시행일: 2026년 4월 6일
        </div>

        <div style={section}>
          <div style={h2}>1. 수집하는 개인정보 항목</div>
          <div style={p}>
            펫말(petmal.kr)은 서비스 제공을 위해 아래 정보를 수집합니다.<br /><br />
            <b>필수 수집 항목 (서비스 이용 시 직접 입력)</b><br />
            - 사용자 이름(또는 별명), 성별<br />
            - 반려동물 정보 (종류, 이름, 성격, 상태)<br />
            - 에피소드 내용 (사용자가 직접 작성한 추억)<br />
            - AI가 생성한 편지 내용<br /><br />
            <b>자동 수집 항목</b><br />
            - 서비스 이용 일시<br />
            - 쿠키 및 광고 관련 식별 정보 (카카오 애드핏)
          </div>
        </div>

        <div style={section}>
          <div style={h2}>2. 개인정보의 수집 및 이용 목적</div>
          <div style={p}>
            - AI 편지 생성 서비스 제공<br />
            - 서비스 품질 개선 및 통계 분석<br />
            - 광고 게재 (카카오 애드핏)
          </div>
        </div>

        <div style={section}>
          <div style={h2}>3. 개인정보의 보유 및 이용 기간</div>
          <div style={p}>
            수집된 정보는 서비스 운영 및 통계 목적으로 보관되며,
            사용자가 삭제를 요청할 경우 지체 없이 파기합니다.
          </div>
        </div>

        <div style={section}>
          <div style={h2}>4. 개인정보의 제3자 제공</div>
          <div style={p}>
            펫말은 사용자의 개인정보를 외부에 제공하지 않습니다.
            단, 아래의 경우는 예외입니다.<br /><br />
            - AI 편지 생성을 위한 Anthropic Claude API 전송 (편지 생성 목적에 한함)<br />
            - 광고 서비스 제공을 위한 카카오 애드핏 (쿠키 기반 광고 식별 정보)<br />
            - 법령에 의해 요구되는 경우
          </div>
        </div>

        <div style={section}>
          <div style={h2}>5. 광고 및 쿠키</div>
          <div style={p}>
            펫말은 카카오 애드핏을 통해 광고를 게재합니다.
            카카오는 사용자의 관심사에 기반한 광고를 표시하기 위해 쿠키를 사용할 수 있습니다.<br /><br />
            - 카카오의 광고 및 개인정보 처리에 대한 자세한 내용은{" "}
            <a href="https://policy.kakao.com/policy/privacy" target="_blank" rel="noopener noreferrer" style={{ color: "#c4845a" }}>
              카카오 개인정보처리방침
            </a>을 참고하세요.<br />
            - 사용자는 브라우저 설정에서 쿠키를 비활성화할 수 있습니다.
          </div>
        </div>

        <div style={section}>
          <div style={h2}>6. 이용자의 권리</div>
          <div style={p}>
            사용자는 언제든지 자신의 개인정보에 대해 열람, 수정, 삭제를 요청할 수 있습니다.<br />
            요청은 아래 연락처로 보내주세요.
          </div>
        </div>

        <div style={section}>
          <div style={h2}>7. 개인정보 보호책임자</div>
          <div style={p}>
            이메일: rnak24@gmail.com
          </div>
        </div>
      </div>
    </div>
  );
}
